const typesEn = {
  stat: 'Stat',
  attribute: 'Attribute',
  skill: 'Skill',
  trait: 'Trait',
  evidence: 'Evidence',
  evidenceCount: 'Evidence count',
  flag: 'Flag',
  turn: 'Turn',
  phase: 'Phase',
  location: 'Current location',
  visitedLocation: 'Visited location',
  unlockedLocation: 'Unlocked location',
  activeSceneNpc: 'Active scene NPC',
  questState: 'Quest state path',
  sceneEventState: 'Scene event state path',
  objectState: 'Object state path',
  npcState: 'NPC state path',
  inventory: 'Inventory item',
  history: 'History query',
  actionIntent: 'Action intent',
  actionTarget: 'Action target',
  claim: 'Claim',
}

const operatorsEn = {
  truthy: 'Exists / true',
  eq: '=',
  is: 'is',
  isNot: 'is not',
  gte: '>=',
  lte: '<=',
  gt: '>',
  lt: '<',
  includes: 'includes',
}

export const conditionMessages = {
  en: {
    condition: 'Condition',
    logic: 'Logic',
    leaf: 'Leaf condition',
    addCondition: 'Add condition',
    key: 'Key',
    value: 'Value',
    last: 'Recent turns',
    logicTypes: { all: 'All', any: 'Any', not: 'Not' },
    types: typesEn,
    operators: operatorsEn,
  },
  zh: {
    condition: '条件',
    logic: '逻辑',
    leaf: '叶子条件',
    addCondition: '新增条件',
    key: '键',
    value: '值',
    last: '最近回合数',
    logicTypes: { all: '全部满足', any: '任一满足', not: '不满足' },
    types: {
      stat: '数值',
      attribute: '属性',
      skill: '技能',
      trait: '特质',
      evidence: '证据',
      evidenceCount: '证据数量',
      flag: 'Flag',
      turn: '回合',
      phase: '阶段',
      location: '当前位置',
      visitedLocation: '已到访地点',
      unlockedLocation: '已解锁地点',
      activeSceneNpc: '当前在场 NPC',
      questState: '任务状态路径',
      sceneEventState: '场景事件状态路径',
      objectState: '物件状态路径',
      npcState: 'NPC 状态路径',
      inventory: '背包物品',
      history: '历史行为',
      actionIntent: '行动意图',
      actionTarget: '行动目标',
      claim: '本回合声明',
    },
    operators: {
      truthy: '存在 / 为真',
      eq: '=',
      is: '等于',
      isNot: '不等于',
      gte: '>=',
      lte: '<=',
      gt: '>',
      lt: '<',
      includes: '包含',
    },
  },
  ja: {
    condition: '条件',
    logic: '論理',
    leaf: '葉条件',
    addCondition: '条件を追加',
    key: 'キー',
    value: '値',
    last: '直近ターン数',
    logicTypes: { all: 'すべて', any: 'いずれか', not: '否定' },
    types: {
      stat: '数値',
      attribute: '属性',
      skill: '技能',
      trait: '特性',
      evidence: '証拠',
      evidenceCount: '証拠数',
      flag: 'Flag',
      turn: 'ターン',
      phase: 'Phase',
      location: '現在地点',
      visitedLocation: '訪問済み地点',
      unlockedLocation: '解放済み地点',
      activeSceneNpc: '場面内 NPC',
      questState: '任務状態パス',
      sceneEventState: '場面イベント状態パス',
      objectState: '物件状態パス',
      npcState: 'NPC 状態パス',
      inventory: '所持品',
      history: '履歴条件',
      actionIntent: '行動意図',
      actionTarget: '行動対象',
      claim: '主張',
    },
    operators: operatorsEn,
  },
  es: {
    condition: 'Condicion',
    logic: 'Logica',
    leaf: 'Condicion hoja',
    addCondition: 'Anadir condicion',
    key: 'Clave',
    value: 'Valor',
    last: 'Turnos recientes',
    logicTypes: { all: 'Todas', any: 'Cualquiera', not: 'No' },
    types: {
      stat: 'Estadistica',
      attribute: 'Atributo',
      skill: 'Habilidad',
      trait: 'Rasgo',
      evidence: 'Evidencia',
      evidenceCount: 'Cantidad de evidencias',
      flag: 'Flag',
      turn: 'Turno',
      phase: 'Fase',
      location: 'Ubicacion actual',
      visitedLocation: 'Ubicacion visitada',
      unlockedLocation: 'Ubicacion desbloqueada',
      activeSceneNpc: 'NPC en escena',
      questState: 'Ruta de estado de mision',
      sceneEventState: 'Ruta de evento',
      objectState: 'Ruta de objeto',
      npcState: 'Ruta de NPC',
      inventory: 'Objeto de inventario',
      history: 'Consulta de historial',
      actionIntent: 'Intencion de accion',
      actionTarget: 'Objetivo de accion',
      claim: 'Declaracion',
    },
    operators: operatorsEn,
  },
  id: {
    condition: 'Kondisi',
    logic: 'Logika',
    leaf: 'Kondisi daun',
    addCondition: 'Tambah kondisi',
    key: 'Key',
    value: 'Nilai',
    last: 'Giliran terbaru',
    logicTypes: { all: 'Semua', any: 'Salah satu', not: 'Bukan' },
    types: {
      stat: 'Stat',
      attribute: 'Atribut',
      skill: 'Skill',
      trait: 'Trait',
      evidence: 'Bukti',
      evidenceCount: 'Jumlah bukti',
      flag: 'Flag',
      turn: 'Giliran',
      phase: 'Fase',
      location: 'Lokasi saat ini',
      visitedLocation: 'Lokasi dikunjungi',
      unlockedLocation: 'Lokasi terbuka',
      activeSceneNpc: 'NPC aktif',
      questState: 'Path status quest',
      sceneEventState: 'Path status event',
      objectState: 'Path status objek',
      npcState: 'Path status NPC',
      inventory: 'Item inventori',
      history: 'Kueri riwayat',
      actionIntent: 'Intent aksi',
      actionTarget: 'Target aksi',
      claim: 'Klaim',
    },
    operators: operatorsEn,
  },
  pt: {
    condition: 'Condicao',
    logic: 'Logica',
    leaf: 'Condicao folha',
    addCondition: 'Adicionar condicao',
    key: 'Chave',
    value: 'Valor',
    last: 'Turnos recentes',
    logicTypes: { all: 'Todas', any: 'Qualquer', not: 'Nao' },
    types: {
      stat: 'Atributo numerico',
      attribute: 'Atributo',
      skill: 'Habilidade',
      trait: 'Traco',
      evidence: 'Evidencia',
      evidenceCount: 'Quantidade de evidencias',
      flag: 'Flag',
      turn: 'Turno',
      phase: 'Fase',
      location: 'Local atual',
      visitedLocation: 'Local visitado',
      unlockedLocation: 'Local desbloqueado',
      activeSceneNpc: 'NPC em cena',
      questState: 'Caminho de estado da missao',
      sceneEventState: 'Caminho de evento',
      objectState: 'Caminho de objeto',
      npcState: 'Caminho de NPC',
      inventory: 'Item de inventario',
      history: 'Consulta de historico',
      actionIntent: 'Intencao de acao',
      actionTarget: 'Alvo de acao',
      claim: 'Declaracao',
    },
    operators: operatorsEn,
  },
}
